export function useArticle(
  path: MaybeRef<`/${'artikler' | 'tilleggsopplysninger'}/${string}`>,
) {
  const { time } = useServerTiming()
  const version = useCrystallizeVersion()
  return useQuery({
    queryKey: ['article', path, version] as const,
    staleTime: 1000 * 60 * 60,
    async queryFn({ queryKey }) {
      const data = await time('GetArticle', () =>
        $crystallizeFetch({
          document: 'page',
          path: queryKey[1],
          version: queryKey[2],
        }))

      return data?.catalogue ? toArticle(data.catalogue) : null
    },
  })
}
